import type { ModelsResolver } from "@/models/resolvers";
import { revisionDefaultFields } from "@/models/resolvers";
import { useLogger } from "@/composables/logger";
import { useCacheOperations } from "@/composables/cache";

const { info: logInfo } = useLogger("SEALS_XREF_RESOLVER");

export default {
  queries: {
    scenario_equipment_xref_seals: {
      seal: (parent, args, cache, info) => {
        return parent.seal_id
          ? { __typename: "seals", id: parent.seal_id }
          : null;
      }
    }
  },
  optimistic: {
    insert_revisions_scenario_equipment_xref_seals_revisions(
      vars,
      cache,
      info
    ) {
      logInfo("Optimistic", { vars, cache, info });
      return {
        __typename:
          "revisions_scenario_equipment_xref_seals_revisions_mutation_response",
        returning: vars.objects.map(object => ({
          id: object.id,
          __typename: "revisions_scenario_equipment_xref_seals_revisions",
          scenario_equipment_xref_seals_view: {
            __typename: "scenario_equipment_xref_seals",
            ...object,
            ...revisionDefaultFields(object),
            seal: null
          }
        }))
      };
    }
  },
  updates: {
    insert_revisions_scenario_equipment_xref_seals_revisions(
      result,
      args,
      cache,
      info
    ) {
      logInfo("Mutation", { result, args, cache, info });
      args.objects.forEach(object => {
        const { handleCacheUpdate } = useCacheOperations({
          cache,
          object,
          typename: "scenario_equipment_xref_seals"
        });

        handleCacheUpdate([
          {
            args: {
              where: {
                journal_deleted_at: {
                  _is_null: true
                }
              }
            },
            relatedCacheKey: cache.keyOfEntity({
              __typename: "scenario_equipment",
              id: object.scenario_equipment_id
            }),
            relatedField: "xref_seals"
          }
        ]);
      });
    }
  }
} as ModelsResolver;
